(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card-grid"] && !Shopify.designMode) return;
  try {
    // ───── Card behaviour (variant change + ajax add-to-cart) ─────
    document.querySelectorAll('.psp-card').forEach(function (card) {
      const select    = card.querySelector('.psp-card__variant-select');
      const hiddenId  = card.querySelector('.psp-card__variant-id');
      const priceEl   = card.querySelector('.psp-card__price');
      const compareEl = card.querySelector('.psp-card__compare');
      const savingsEl = card.querySelector('.psp-card__savings-amount');
      if (!select) return;

      function fmt(cents) { return '₹' + Math.round(cents / 100); }

      select.addEventListener('change', function (e) {
        const opt = e.target.options[e.target.selectedIndex];
        const variantId = opt.value;
        const price   = parseInt(opt.dataset.price, 10)   || 0;
        const compare = parseInt(opt.dataset.compare, 10) || 0;
        const savings = parseInt(opt.dataset.savings, 10) || 0;

        hiddenId.value = variantId;
        if (priceEl) priceEl.textContent = fmt(price);
        if (compareEl) {
          if (compare > price) {
            compareEl.textContent = fmt(compare);
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
        if (savingsEl) savingsEl.textContent = fmt(savings);
      });

      // const btn = card.querySelector('.psp-card__add-btn');
      // if (!btn) return;

      // function handleAdd(e) {
      //   card.pspHandleAdd = handleAdd;
      //   if (e) { e.preventDefault(); if (e.stopImmediatePropagation) e.stopImmediatePropagation(); }

      //   const variantInput = card.querySelector('.psp-card__variant-id');
      //   const variantId = variantInput ? variantInput.value : null;
      //   if (!variantId) {
      //     console.error('PSP best-sellers: no variant ID on card', card);
      //     btn.textContent = 'NO VARIANT';
      //     setTimeout(function () { btn.textContent = 'ADD TO CART'; }, 1800);
      //     return;
      //   }

      //   const originalText = btn.textContent;
      //   btn.disabled = true;
      //   btn.textContent = 'ADDING...';

      //   const renderSections = ['cart-icon-bubble', 'cart-live-region-text', 'cart-drawer', 'cart-notification', 'header'];

      //   fetch('/cart/add.js', {
      //     method: 'POST',
      //     headers: {
      //       'Content-Type': 'application/json',
      //       'Accept': 'application/json',
      //       'X-Requested-With': 'XMLHttpRequest'
      //     },
      //     body: JSON.stringify({
      //       items: [{ id: parseInt(variantId, 10), quantity: 1 }],
      //       sections: renderSections.join(','),
      //       sections_url: window.location.pathname
      //     })
      //   })
      //     .then(function (res) {
      //       return res.json().then(function (data) {
      //         if (!res.ok) {
      //           throw new Error(data.description || data.message || ('HTTP ' + res.status));
      //         }
      //         return data;
      //       });
      //     })
      //     .then(function (item) {
      //       console.log('PSP best-sellers: added to cart', item);
      //       btn.textContent = '✓ ADDED';


      //       if (item.sections) {
      //         Object.keys(item.sections).forEach(function (sectionId) {
      //           const html = item.sections[sectionId];
      //           if (!html) return;
      //           const newDoc = new DOMParser().parseFromString(html, 'text/html');

      //           const newEl = newDoc.getElementById(sectionId) ||
      //                         newDoc.querySelector('[data-section-id="' + sectionId + '"]') ||
      //                         newDoc.body.firstElementChild;
      //           const currentEl = document.getElementById(sectionId) ||
      //                             document.querySelector('[data-section-id="' + sectionId + '"]') ||
      //                             document.getElementById('shopify-section-' + sectionId);
      //           if (newEl && currentEl) {
      //             currentEl.innerHTML = newEl.innerHTML;
      //           }
      //         });
      //       }


      //       const cartNotif  = document.querySelector('cart-notification');
      //       const cartDrawer = document.querySelector('cart-drawer');
      //       if (cartNotif && typeof cartNotif.renderContents === 'function') {
      //         try { cartNotif.renderContents(item); } catch (_) {}
      //       } else if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      //         try { cartDrawer.renderContents(item); } catch (_) {}
      //       }

      //       fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      //         .then(function (r) { return r.json(); })
      //         .then(function (cart) {
      //           const count = cart.item_count;

      //           document.querySelectorAll('[data-cart-count], .cart-products-count').forEach(function (el) {
      //             if (el.children.length === 0) el.textContent = count;
      //           });

      //           document.dispatchEvent(new CustomEvent('cart:updated',      { detail: cart }));
      //           document.dispatchEvent(new CustomEvent('cart:refresh',      { detail: cart }));
      //           document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: item }));
      //           console.log('PSP best-sellers: cart count painted →', count);
      //         })
      //         .catch(function () {});

      //       const drawer = document.querySelector('cart-drawer');
      //       if (drawer && typeof drawer.open === 'function') {
      //         try { drawer.open(); } catch (_) {}
      //       }
      //       const drawerTrig = document.querySelector('[data-cart-drawer-toggle], .js-drawer-open-cart, .cart-drawer-trigger');
      //       if (drawerTrig) { try { drawerTrig.click(); } catch (_) {} }

      //       setTimeout(function () {
      //         btn.textContent = originalText;
      //         btn.disabled = false;
      //       }, 1400);
      //     })
      //     .catch(function (err) {
      //       console.error('PSP best-sellers: add to cart failed —', err);
      //       const msg = (err && err.message ? err.message : 'ERROR').substring(0, 24);
      //       btn.textContent = msg.toUpperCase();
      //       setTimeout(function () {
      //         btn.textContent = originalText;
      //         btn.disabled = false;
      //       }, 2400);
      //     });
      // }

      // btn.addEventListener('click', handleAdd);


      // card.addEventListener('submit', handleAdd);
    });
    

// .........................................

document.body.addEventListener('click', function(e){

  const btn = e.target.closest('.psp-card__add-btn');

  if(!btn) return;

  e.preventDefault();

  // e.stopImmediatePropagation();


  if(btn.dataset.loading === 'true') return;

  btn.dataset.loading = 'true';



  const card = btn.closest('.psp-card');

  if(!card){

    btn.dataset.loading = 'false';

    return;

  }



  const variantInput = card.querySelector('.psp-card__variant-id');

  if(!variantInput){

    btn.dataset.loading = 'false';

    return;

  }



  const variantId = variantInput.value;

  const originalText = btn.textContent;



  btn.disabled = true;

  btn.textContent = 'ADDING...';



  fetch('/cart/add.js', {

    method: 'POST',

    headers: {

      'Content-Type': 'application/json',

      'Accept': 'application/json',

      'X-Requested-With': 'XMLHttpRequest'

    },

    body: JSON.stringify({

      items: [{

        id: parseInt(variantId),

        quantity: 1

      }]

    })

  })

  .then(res => res.json())

  .then(item => {



    btn.textContent = '✓ ADDED';



    return fetch('/cart.js');

  })

  .then(r => r.json())

  .then(cart => {



    document.querySelectorAll('[data-cart-count], .cart-products-count')

    .forEach(el => {

      if(el.children.length === 0){

        el.textContent = cart.item_count;

      }

    });



    fetch('/?section_id=cart-drawer')
   


    .then(response => response.text())

    .then(html => {

      const parser = new DOMParser();

      const doc = parser.parseFromString(html, 'text/html');

      const newDrawer = doc.querySelector('cart-drawer');

      const currentDrawer = document.querySelector('cart-drawer');

      if(newDrawer && currentDrawer){

        currentDrawer.innerHTML = newDrawer.innerHTML;

      }


      const emptyTexts = currentDrawer.querySelectorAll(

        '.cart-empty, .drawer__empty, .is-empty, .cart--empty, .empty-cart-message'

      );



      if(cart.item_count > 0){

        emptyTexts.forEach(el => {

          el.style.display = 'none';

        });

      }



      const drawer = document.querySelector('cart-drawer');



      if(drawer && typeof drawer.open === 'function'){

        drawer.open();

      } else {

        const trigger = document.querySelector(

          '[data-cart-drawer-toggle], .js-drawer-open-cart, .cart-drawer-trigger'

        );



        if(trigger){

          trigger.click();

        }

      }

    });




    document.dispatchEvent(new CustomEvent('cart:updated', {

      detail: cart

    }));



    document.dispatchEvent(new CustomEvent('cart:refresh', {

      detail: cart

    }));




    setTimeout(() => {

      btn.disabled = false;

      btn.dataset.loading = 'false';

      btn.textContent = originalText;

    }, 1400);

  })

  .catch(err => {



    console.error(err);



    btn.textContent = 'ERROR';



    setTimeout(() => {

      btn.disabled = false;

      btn.dataset.loading = 'false';

      btn.textContent = originalText;

    }, 1500);

  });

});
  } catch(e) { console.error(e); }
})();

})();
